;(function module() {
  angular
    .module('app.emailBodyView', [
      'pascalprecht.translate',
      'angularFileUpload',
      'angular.filter',
      'ngSlider',
      'ngCookies',
      'ngAnimate',
      'ngSanitize',
      'angularSpinner',
      'angular-clipboard',
      'ui.nested.combobox',
    ])
    .controller('EmailPreviewController', [
      '$location',
      '$sce',
      function controller($location, $sce) {
        let vm = this
        vm.email = $location.search().emailCategory
        vm.emailContent = $sce.trustAsHtml(vm.email.content)
        // TODO: Removed as per discussion will Implement History Functionality in v.1.1.0
        // vm.backButton = () => {
        //   return $location.url('/admin/email-history')
        // }

        vm.navigateToEmailListing = () => {
          $location.url('/admin/email-listing')
        }

        return vm.navigateToEmailListing()
      },
    ])
}.call(this))



// WEBPACK FOOTER //
// ./scripts/admin-panel/email-listing/email-preview/email-preview.ctrl.js